import axios from "axios";
import swal from "sweetalert";
import { api_path } from "../../shared";
import EditOrderModal from "./EditOrderModal";
function onPreivewButtonClick(order_id) {
  window.open(
    "/s-crm/SalesOrderDetail?order_id=" + order_id + "&loadtype=fcl" + "_blank"
  );
}
function onSendOrderButtonClick(order_id, userid) {
  swal({
    title: "Are you sure to send this order?",
    text: "",
    icon: "info",
    dangerMode: false,
    buttons: true,
  }).then((isConfirm) => {
    if (isConfirm) {
      updateOrderStatus(order_id, 1, "", userid);
    }
  });
}
function updateOrderStatus(ORDER_ID, ORDER_STATUS, REMARK, USER_ID) {
  var data = {
    ORDER_ID: ORDER_ID,
    ORDER_STATUS: ORDER_STATUS,
    REMARK: REMARK,
    REASON_ID: "",
    REASON_NAME: "",
    USER_ID: USER_ID,
  };
  fetch(api_path + "/TS_SALES_ORDER_UPDATE_STATUS.php", {
    method: "POST",
    headers: {
      Accept: "application/form-data",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((result) => {
      if (result["status"] == "200") {
        swal("Done.", "Save data successfully.", "success", {
          buttons: true,
          timer: 5000,
        }).then(function () {
          const url =
            api_path +
            "/SENDMAIL_SALESORDER.php?order_id=" +
            ORDER_ID +
            "&order_status=" +
            ORDER_STATUS;
          axios
            .get(url)
            .then((response) => {
              // handle success
              console.log(result["message"]);
            })
            .then((data) => {
              console.log(data);
              // Handle data
            })
            .catch((error) => {
              // handle errors
            });
          window.location.reload();
          ////////////////////////////////////////////////////
        });
      } else {
        swal("Sorry", result["message"], "error", {
          buttons: true,
          timer: 1000,
        });
      }
    });
}
function DupOrderDataview(props) {
  return (
    <tbody>
      <tr>
        <td style={{ width: "50px" }}>{props.ORDER_NO}</td>
        <td style={{ width: "10%" }}>{props.QUOTATION_NO}</td>
        <td style={{ width: "10%" }}>{props.CUSTOMER_REF}</td>
        <td>{props.CNT20}</td>
        <td>{props.TYPE20}</td>
        <td>{props.GW20}</td>
        <td>{props.CNT40}</td>
        <td>{props.TYPE40}</td>
        <td>{props.GW40}</td>
        <td>{props.CNT40HQ}</td>
        <td>{props.TYPE40HQ}</td>
        <td>{props.GW40HQ}</td>
        <td>{props.CNT45}</td>
        <td>{props.TYPE45}</td>
        <td>{props.GW45}</td>
        <td>Draft</td>
        <td style={{ width: "5%" }}>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => onPreivewButtonClick(props.id)}
          >
            Preview
          </button>
        </td>
        <td style={{ width: "5%" }}>
          <EditOrderModal
            ORDER_ID={props.id}
            ORDER_NO={props.ORDER_NO}
            QUOTATION_NO={props.QUOTATION_NO}
            CUSTOMER_REF={props.CUSTOMER_REF}
            CNT20={props.CNT20}
            TYPE20={props.TYPE20}
            GW20={props.GW20}
            CNT40={props.CNT40}
            TYPE40={props.TYPE40}
            GW40={props.GW40}
            CNT40HQ={props.CNT40HQ}
            TYPE40HQ={props.TYPE40HQ}
            GW40HQ={props.GW40HQ}
            CNT45={props.CNT45}
            TYPE45={props.TYPE45}
            GW45={props.GW45}
            CARGO_READY={props.CARGO_READY}
            ETD_DATE={props.ETD_DATE}
            ETA_DATE={props.ETA_DATE}
            RETURN_DATE={props.RETURN_DATE}
            CY_DATE={props.CY_DATE}
          />
        </td>
        <td style={{ width: "5%" }}>
          <button
            className="btn btn-primary btn-sm green"
            onClick={() => onSendOrderButtonClick(props.id, props.USERID)}
          >
            Send
          </button>
        </td>
      </tr>
    </tbody>
  );
}

export default DupOrderDataview;
